<template>
  <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
    <path
      d="M17.0366 14.205C17.8321 13.0528 18.2989 11.6559 18.2989 10.1494C18.2989 6.20098 15.0986 3 11.1494 3C7.20031 3 4 6.20095 4 10.1494C4 14.0979 7.20031 17.2989 11.1494 17.2989C12.7978 17.2989 14.3146 16.7397 15.5238 15.8027L19.7211 20L21.2765 18.4448L17.0366 14.205ZM11.1494 15.759C8.05631 15.759 5.53987 13.2426 5.53987 10.1494C5.53987 7.05627 8.05624 4.53984 11.1494 4.53984C14.2427 4.53984 16.759 7.0562 16.759 10.1494C16.759 13.2426 14.2426 15.759 11.1494 15.759V15.759Z"
      fill="currentColor"
    />
    <path
      d="M11.9185 9.48958V6.73975H10.3787V9.48958H7.62891V11.0295H10.3787V13.7792H11.9185V11.0295H14.6683V9.48958H11.9185Z"
      fill="currentColor"
    />
  </svg>
</template>
